export default function isIncludedIn<I, A extends ReadonlyArray<I>>(
  value: I,
  array: A
): value is A[number] {
  return array.includes(value);
}
